import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentTrials } from '../services/get-current-trials.service';
import { RequestStatus } from '../interface';
import { selectCurrentTrialsState } from '../selectors';
import { dataFetchingErrorHandler } from '../errors/dataFetchingErrorHandler';
export const getCurrentTrialsThunk = createAsyncThunk('getCurrentTrials', async (portalId, {
  rejectWithValue
}) => {
  // Skipping fetching current trials if portalId is not provided (hubless)
  if (!portalId) {
    return [];
  }
  try {
    return await getCurrentTrials(portalId);
  } catch (error) {
    const requestError = error;
    dataFetchingErrorHandler('Failed to fetch current trials')(requestError);
    return rejectWithValue([]);
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectCurrentTrialsState(state);
    return status === RequestStatus.IDLE;
  }
});